import queryCallToAction from '@ms/yammer-graphql/dist/operations/queryViewerCallToAction.graphql';
import { reportError } from '@ms/yammer-telemetry';

import type { ManagedApiLifecycle } from '../..';
import { getGraphqlApiRequest, getTreatmentsExtensionForGraphqlBody, managedApiAction } from '../..';
import type { SuggestedActionSurface } from '../../state/suggestedActions/types';
import type { PromiseThunkAction } from '../../types';

import type { SuggestedActionsResponse } from './actions.types';

const maxSuggestedActions = 6;

type LoadSuggestedActions = (
  lifecycle: ManagedApiLifecycle<SuggestedActionsResponse>,
  surface: SuggestedActionSurface
) => PromiseThunkAction<void>;
export const loadSuggestedActions: LoadSuggestedActions = (lifecycle, surface) => async (dispatch, getState) => {
  try {
    const state = getState();

    const treatments = getTreatmentsExtensionForGraphqlBody({
      state,
      featureRollouts: ['SuggestedActionFollowUsersIgnoreCheck', 'SuggestedActionIgnoreMaxJoinedGroups'],
    });

    const query = {
      body: {
        operationName: 'ViewerCallToActionClients',
        query: queryCallToAction,
        variables: {
          surface,
          count: maxSuggestedActions,
          context: {
            feedType: 'HOME',
            feedSubtype: 'ALL',
            contextIds: [],
          },
        },
      },
      treatments,
    };

    const request = getGraphqlApiRequest(query);

    const action = managedApiAction({
      request,
      lifecycle,
    });

    await dispatch(action);
  } catch (error) {
    reportError({
      error,
    });
  }
};
